import { MealPreferencesService } from "@/clients/services/MealPreferencesService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetFoodAvoids = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.FOOD_AVOIDS],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealPreferencesService.getGeneralMealPreferencesAvoidsApiV1MealPreferencesGeneralAvoidsGet(
          user.id,
        );
      return data;
    },
  });

  return {
    foodAvoids: data,
    isLoading,
    error,
  };
};
